import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm border font-semibold transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:size-[15px] [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'border-input bg-popover text-foreground hover:border-dim-2 hover:bg-[#23262e]',
        primary:
          'border-primary bg-primary text-primary-foreground shadow-[0_3px_12px_rgba(255,93,70,0.25)] hover:border-[#ff6f5a] hover:bg-[#ff6f5a]',
        ghost: 'border-transparent bg-transparent text-muted-foreground hover:bg-popover hover:text-foreground',
      },
      size: {
        md: 'px-[15px] py-2.5 text-[13px]',
        sm: 'px-[11px] py-[7px] text-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
